export const key = 'Q7W4quSFf6dlW8TG16rR2DNZJLjhfujm';

export const baseURL = 'https://api.tizacam.com/';